<section class="page-shell">
  <header class="page-shell__header">
    <div class="page-shell__heading">
      @if (badge()) {
        <span class="page-shell__badge">{{ badge() }}</span>
      }
      <h1 class="page-shell__title">{{ title() }}</h1>
      @if (description()) {
        <p class="page-shell__description">{{ description() }}</p>
      }
    </div>
    <div class="page-shell__actions">
      <ng-content select="[shell-actions]" />
    </div>
  </header>

  <div class="page-shell__body">
    <ng-content />
  </div>
</section>
